/* eslint-disable react-hooks/exhaustive-deps */
import { Suspense } from "react";
import LeftMenu from "../../../components/admin/leftMenu";
import TopMenu from "../../../components/admin/topMenu";
import Footer from "../../admin/footer";
import { Outlet } from "react-router-dom";

const AdminUserLayout = () => {
  return (
    <>
      <Suspense fallback={<></>}>
        <div id="wrapper">
          <LeftMenu />
          <div id="content-wrapper" className="d-flex flex-column">
            <div id="content">
              <TopMenu />
              <Outlet />
            </div>
            <Footer />
          </div>
        </div>
      </Suspense>
    </>
  );
};

export default AdminUserLayout;
